import axios from '../../../config/axiosConfig';
import { Admin, ExportDocumentTypes, ExportFormat } from '../../../shared';
import { ErrorResponse } from '../../../shared';
import { IGender, IJurisdiction, IRace, IComparisonDropdownResponse, IComparisonReportResponse, IComparisonReport, IComparisonReportData } from './StudentComparison.interfaces';

export const printComparisonReport = (): void => {
  const printableDiv = document.getElementById('section-to-print');
  if (!printableDiv) return;

  const originalContents = document.body.innerHTML;
  document.body.innerHTML = printableDiv.innerHTML;
  window.print();
  document.body.innerHTML = originalContents;
};

export const fetchComparisonDropdowns = async (admin: Admin, abortController: AbortController):
  Promise<IComparisonDropdownResponse | ErrorResponse> => {
  const body = {adminID: admin.administrationID};
  // await new Promise(resolve => setTimeout(resolve, 0));
  // return SAMPLE_DATA;

  const response = await axios.post<IComparisonDropdownResponse>(
    'api/report/compReportLists', body, { signal: abortController.signal }
  )
    .then((res): IComparisonDropdownResponse => ({ ...res.data, __typename: 'StudentDropdownResponse' }))
    .catch((errMsg): ErrorResponse => ({ __typename: 'ErrorResponse', errMsg }));
  return response;
};


//CompReport
export const fetchComparisonReport = async (admin: Admin,
  jurisdiction: IJurisdiction, gender: IGender, race: IRace, abortController: AbortController):
  Promise<IComparisonReportResponse | ErrorResponse> => {
  const body = {
    AdminId: admin.administrationID,
    selectedJurisdiction: { code: jurisdiction.value.code, label: jurisdiction.value.label },
    selectedGender: { code: gender.code, label: gender.value },
    selectedRace: { code: race.code, label: race.value }
  };
  // await new Promise(resolve => setTimeout(resolve, 0));
  // return SAMPLE_DATA;

  const response = await axios.post<IComparisonReport>(
    'api/report/CompReport', body, { signal: abortController.signal }
  )
    .then((res): IComparisonReportResponse => (
      { comparisonReport: res.data,
        __typename: 'ComparisonReportResponse' }
    )
    )
    .catch((errMsg): ErrorResponse => ({ __typename: 'ErrorResponse', errMsg }));
  return response;
};



// // eslint-disable-next-line @typescript-eslint/no-explicit-any
// function appendFormData(formData: FormData, keyBase: string, data: any) {
//   if (data && typeof data === 'object' && !(data instanceof File)) {
//     Object.keys(data).forEach((key) => {
//       const fullKey = `${keyBase}${keyBase ? '.' : ''}${key}`;
//       if (data[key] && typeof data[key] === 'object' && !(data[key] instanceof File)) {
//         Object.keys(data[key]).forEach((subKey) => {
//           const subFullKey = `${fullKey}[${subKey}]`;
//           appendFormData(formData, subFullKey, data[key][subKey]);
//         });
//       } else {
//         formData.append(fullKey, data[key]);
//       }
//     });
//   } else {
//     formData.append(keyBase, data);
//   }
// }

// function convertArrayToFormData(reports: IComparisonReportData[]): FormData {
//   const formData = new FormData();

//   reports.forEach((report, index) => {
//     appendFormData(formData, `reports[${index}]`, report);
//   });

//   return formData;
// }

// export function jsonToFormData(jsonData: IComparisonReportData[], files: FileArray, exportSignal: ExportFormat = 'XLS'): FormData {
// ;

//   return formData;
// }

export const downloadComparisonReport = async (compReport: IComparisonReportData[], exportSignal: ExportFormat ): Promise<boolean> => {
  const body = {reports: compReport, exportFormat: exportSignal, documentType: 'Comparison' as ExportDocumentTypes};
  // const formData = {reports: compReport, files: [] };
  const url = 'api/export/reportexport';
  try {
    const response = await axios.post<Blob>(url, body, { responseType: 'blob'});
    // Create a new Blob object using the response data of the file
    const file = new Blob([response.data], { type: response.headers['content-type'] });
    const contentDisposition = response.headers['content-disposition'] as string;

    let fileName = '';
    const regex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/gi;
    const matches = regex.exec(contentDisposition);
    if (matches != null && matches[1]) {
      fileName = matches[1].replace(/['"]/g, ''); // Remove any surrounding quotes
      console.log(fileName);
    }
    // Create a link to the file
    const fileURL = URL.createObjectURL(file);

    // Create a temporary anchor tag and trigger a download
    const fileLink = document.createElement('a');
    fileLink.href = fileURL;
    fileLink.setAttribute('download', fileName);
    document.body.appendChild(fileLink);
    fileLink.click();

    // Clean up by removing the link and revoking the object URL
    document.body.removeChild(fileLink);
    URL.revokeObjectURL(fileURL);
    return true;
  } catch(err) {
    return false;
  }
};


// export const SAMPLE_DATA: IComparisonReportResponse = {
//   __typename: 'ComparisonReportResponse',
//   comparisonReport: {
//     'reportDataExists': true,
//     'reportData': [
//       {
//         'footnotes': [
//           {
//             'symbol': '',
//             'footnoteText': 'NOTE:  An off-task response is a response that is unrelated to the question and is therefore considered inappropriate. An omitted response is a missing response prior to the last observed response.  Detail may not sum to totals because of rounding. Some apparent differences between estimates may not be statistically significant.'
//           },
//           {
//             'symbol': '',
//             'footnoteText': 'SOURCE: U.S. Department of Education, Institute of Education Sciences, National Center for Education Statistics, National Assessment of Educational Progress (NAEP), 2017 Mathematics Assessment.'
//           }
//         ],
//         'notes': [],
//         'rows': [
//           {
//             'rowCells': [
//               {
//                 'stringValue': 'Item Seq. #',
//                 'dataValue': -1.0,
//                 'rowSpan': 1,
//                 'colSpan': 1
//               },
//               {
//                 'stringValue': 'Question Description',
//                 'dataValue': -1.0,
//                 'rowSpan': 1,
//                 'colSpan': 1
//               },
//               {
//                 'stringValue': 'NAEP % Correct',
//                 'dataValue': -1.0,
//                 'rowSpan': 1,
//                 'colSpan': 1
//               },
//               {
//                 'stringValue': 'Your % Correct',
//                 'dataValue': -1.0,
//                 'rowSpan': 1,
//                 'colSpan': 1
//               }
//             ],
//             'rowType': 0
//           },
//           {
//             'rowCells': [
//               {
//                 'stringValue': '1.',
//                 'dataValue': -1.0,
//                 'rowSpan': 1,
//                 'colSpan': 1
//               },
//               {
//                 'stringValue': 'Complete a circle graph to represent data in a table',
//                 'dataValue': -1.0,
//                 'rowSpan': 1,
//                 'colSpan': 1
//               },
//               {
//                 'stringValue': '93.85',
//                 'dataValue': -1.0,
//                 'rowSpan': 1,
//                 'colSpan': 1
//               },
//               {
//                 'stringValue': '100',
//                 'dataValue': -1.0,
//                 'rowSpan': 1,
//                 'colSpan': 1
//               }
//             ],
//             'rowType': 1
//           },
//           {
//             'rowCells': [
//               {
//                 'stringValue': '2.',
//                 'dataValue': -1.0,
//                 'rowSpan': 1,
//                 'colSpan': 1
//               },
//               {
//                 'stringValue': 'Find the product of two two-digit decimals',
//                 'dataValue': -1.0,
//                 'rowSpan': 1,
//                 'colSpan': 1
//               },
//               {
//                 'stringValue': '47.34',
//                 'dataValue': -1.0,
//                 'rowSpan': 1,
//                 'colSpan': 1
//               },
//               {
//                 'stringValue': '100',
//                 'dataValue': -1.0,
//                 'rowSpan': 1,
//                 'colSpan': 1
//               }
//             ],
//             'rowType': 1
//           },
//           {
//             'rowCells': [
//               {
//                 'stringValue': '3.',
//                 'dataValue': -1.0,
//                 'rowSpan': 1,
//                 'colSpan': 1
//               },
//               {
//                 'stringValue': 'Determine the x- & y- intercepts of a given line',
//                 'dataValue': -1.0,
//                 'rowSpan': 1,
//                 'colSpan': 1
//               },
//               {
//                 'stringValue': '61.07',
//                 'dataValue': -1.0,
//                 'rowSpan': 1,
//                 'colSpan': 1
//               },
//               {
//                 'stringValue': '100',
//                 'dataValue': -1.0,
//                 'rowSpan': 1,
//                 'colSpan': 1
//               }
//             ],
//             'rowType': 1
//           },
//           {
//             'rowCells': [
//               {
//                 'stringValue': '4.',
//                 'dataValue': -1.0,
//                 'rowSpan': 1,
//                 'colSpan': 1
//               },
//               {
//                 'stringValue': 'Compare measurements using unit conversions',
//                 'dataValue': -1.0,
//                 'rowSpan': 1,
//                 'colSpan': 1
//               },
//               {
//                 'stringValue': '72.31',
//                 'dataValue': -1.0,
//                 'rowSpan': 1,
//                 'colSpan': 1
//               },
//               {
//                 'stringValue': '100',
//                 'dataValue': -1.0,
//                 'rowSpan': 1,
//                 'colSpan': 1
//               }
//             ],
//             'rowType': 1
//           },
//           {
//             'rowCells': [
//               {
//                 'stringValue': '5.',
//                 'dataValue': -1.0,
//                 'rowSpan': 1,
//                 'colSpan': 1
//               },
//               {
//                 'stringValue': 'Extend a numerical pattern given both a verbal and numerical description',
//                 'dataValue': -1.0,
//                 'rowSpan': 1,
//                 'colSpan': 1
//               },
//               {
//                 'stringValue': '43.88',
//                 'dataValue': -1.0,
//                 'rowSpan': 1,
//                 'colSpan': 1
//               },
//               {
//                 'stringValue': '100',
//                 'dataValue': -1.0,
//                 'rowSpan': 1,
//                 'colSpan': 1
//               }
//             ],
//             'rowType': 1
//           },
//           {
//             'rowCells': [
//               {
//                 'stringValue': 'Average',
//                 'dataValue': -1.0,
//                 'rowSpan': 1,
//                 'colSpan': 1
//               },
//               {
//                 'stringValue': '',
//                 'dataValue': -1.0,
//                 'rowSpan': 1,
//                 'colSpan': 1
//               },
//               {
//                 'stringValue': '63.69',
//                 'dataValue': -1.0,
//                 'rowSpan': 1,
//                 'colSpan': 1
//               },
//               {
//                 'stringValue': '0',
//                 'dataValue': -1.0,
//                 'rowSpan': 1,
//                 'colSpan': 1
//               }
//             ],
//             'rowType': 3
//           }
//         ],
//         'headerInfo': {
//           'Comparison Report': '',
//           'Assessment: ': 'Mathematics Grade 8-03/08/2024 7:29:36 AM',
//           'Jurisdiction: ': 'National',
//           'Gender: ': 'All',
//           'Race/Ethnicity: ': 'All'
//         }
//       }
//     ]
//   }
// };